export default (function (length, index, defaultUserString, userWithComma, userWithAnd) {
    if (length === 2 && index === 1) {
        return userWithAnd;
    }
    else if (length > 2) {
        if (index === length - 1) {
            return userWithAnd;
        }
        else if (index !== length - 2) {
            return userWithComma;
        }
    }
    return defaultUserString;
});
